/* src/app/main/pages/services/value-added-service/value-added-service.component.css */
/*# sourceMappingURL=value-added-service.component.css.map */
